/**
 *
 * 单页面，只有一个请求的页面基类
 * @param app
 * @param option 参数传递
 */

import {decryptMessageByObject} from '@/util/secret'
import baseCrudExportPlugin from './baseCrudPlugin_export'

export default (app, option = {}) => {
	let mixins = {
		name: option.name,
		data() {
			return {
				listData: [],
				isNeedQuery: true, //是否需要查询数据
				optionData: require(`@/const/crud/${option.optionPath}`),
				currentOption: {},
				//接口
				api: require(`@/api/${option.apiPath}`),
				formData: {},
				searchParams: {},
				tableLoading: true,
				exportAllBtn: false,
				page: {
					total: 0,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [20, 40, 80, 100, 500, 1000],
				},
				isChangeTabs: true,
				//多个tab
				currentIndex: '0',
				isNeedRefreshTable: true,
				//切换table 是否清空搜索
				isRecycleSearchData: true,
			}
		},
		computed: {
			//绑定的参数
			bindVal() {
				return {
					ref: 'crud_content',
					option: this.currentOption,
					data: this.listData,
					'v-model': this.formData,
					tableLoading: this.tableLoading,
				}
			},
			onEvent() {
				return {
					'row-save': this.rowSave,
					'row-update': this.rowUpdate,
					'row-del': this.rowDel,
				}
			},
			rowKey() {
				return option.rowKey || 'id'
			},
		},
		watch: {
			//更改current index
			currentIndex(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.currentIndex = newVal
					//设置表头
					this.$refs.crud_content.clearSelection()
					this.initCurrentOptionData(this.currentIndex)
					//切换tab 请求回调
					this.onChangeIndex()
				}
			},
		},
		created() {
			this.tableLoading = this.isNeedQuery
			//初始化数据
			this.initCurrentOptionData('0', false)
		},
		activated() {
			//从路由上获取参数，判断是否需要更新
			let {isRefresh = false} = this.$route.query || {}
			if (isRefresh) {
				this.refreshChange()
			}
		},
		deactivated() {},
		methods: {
			//设置当前的option,以及数据
			initCurrentOptionData(index, isNotFirstInit = true) {
				this.currentIndex = index
				if (this.isRecycleSearchData) {
					//重新设置搜索内容
					this.searchParams = {}
				}
				//初始化分页
				this.initPage()
				//设置表头
				this.currentOption = this.deepClone(this.optionData[option.optionNameList[parseInt(this.currentIndex)]](this))
				if (isNotFirstInit) {
					//如果不是第一次请求，则必须调用getList
					this.getList()
				}
				// this.$nextTick(() => {
				//     this.$refs.crud_content.doLayout();
				// })
			},
			//请求参数
			getListReqData() {
				let pageParams = {}
				//处理数据 -- 适配
				pageParams['pageNo'] = this.page.currentPage
				pageParams['page'] = this.page.currentPage
				pageParams['pageSize'] = this.page.pageSize
				pageParams['current'] = this.page.currentPage
				pageParams['size'] = this.page.pageSize
				//处理search搜索时间
				let {searchData} = option
				if (searchData && searchData.length === 3) {
					let [time = '', startTime = '', endTime = ''] = searchData
					if (!this.validatenull(time)) {
						let timeData = this.searchParams[time]
						if (timeData && timeData.length === 2) {
							let [one = '', two = ''] = timeData
							if (one && two) {
								//如果 one 没有包含空格
								if (!one.includes(' ')) {
									one = `${one} 00:00:00`
								}
								if (!two.includes(' ')) {
									two = `${two} 23:59:59`
								} else if (two.includes('00:00:00')) {
									two = two.replace('00:00:00', '23:59:59')
								}
							}
							this.searchParams[startTime] = one
							this.searchParams[endTime] = two
							this.searchParams[time] = undefined
						}
					}
				}
				return Object.assign(pageParams, this.searchParams, this.addRequestData(), {sortType: 2})
			},
			addRequestData() {
				return {}
			},
			listBefore() {},
			//请求数据
			getList() {
				//判断是否需要发送请求查询数据
				if (!this.isNeedQuery) {
					return
				}
				//请求之前
				this.isChangeTabs = true
				this.tableLoading = true
				//获取请求参数
				let requestData = this.getListReqData()
				//发起请求
				this.listData = []
				this.listBefore()
				this.requestListData(requestData)
			},
			//请求数据接口
			requestListData(requestData) {
				//请求  如有
				this.api[option.apiNameList[parseInt(this.currentIndex)]](requestData)
					.then((response) => {
						//处理数据
						if (!response) {
							this.$message.error('数据有误!')
							return
						}
						//处理分页
						let {data = {}} = response.data || {}
						//如果data是对象，不是array
						if (!Array.isArray(data)) {
							this.page.total = data.total || 0
						}
						this.dealResponseData(response)
						//请求之后处理，根据currentIndex
						this.listAfter()
					})
					.catch(() => {
						//请求错误处理
						this.listError()
					})
					.finally(() => {
						this.tableLoading = false
						this.isChangeTabs = false
						//请求最后处理
						this.listFinally()
						if (this.isNeedRefreshTable && this.$refs.crud_content) {
							this.$nextTick(() => {
								if (this.$refs.crud_content) {
									this.$refs.crud_content.refreshTable()
								}
							})
						}
					})
			},
			listFinally() {},
			//处理请求参数
			dealResponseData(response) {
				let {data} = response.data
				let request = option.apiNameList[parseInt(this.currentIndex)]
				if (
					request === 'getSettlementOrdersBasic' ||
					request === 'getSettleApplyDetail' ||
					request === 'getSettleApplyDetailAward'
				) {
					this.page.total = 0
					//处理钱 ，没有分页
					this.dealFontMoney(data, request)
				} else if (request === 'getNoApplyList' || request === 'getSettleApplyDetailPage') {
					this.page.total = data['total']
					this.dealFontMoney(data['records'], request)
				} else if (request === 'getSettlementOrdersAward' || request === 'getSettleApplyDetailAward') {
					//奖励结算申请
					this.page.total = 0
					this.dealAwardFontMoney(data)
					this.listData = data
				} else if (request === 'getAwardList') {
					this.page.total = data['total']
					let tempRecord = data['records']
					this.dealAwardFontMoney(tempRecord, false)
					this.listData = tempRecord
				} else {
					//处理数据
					this.page.total = data['total']
					this.listData = data['records']
				}
			},
			rowSaveReqData() {
				return this.formData
			},
			//新增/修改之前的校验方法 用于校验数据
			checkForm(formData) {
				return true
			},
			//新增
			async rowSave(row, done, loading) {
				if (!this.checkForm(this.formData)) {
					loading()
					return
				}
				let {apiNameAddList} = option

				this.api[apiNameAddList ? apiNameAddList[parseInt(this.currentIndex)] : 'add'](await this.rowSaveReqData())
					.then((response) => {
						this.getList()
						this.$message.success('新增成功')
						done()
					})
					.catch(() => {
						loading()
					})
			},
			rowUpdateReqData() {
				return this.formData
			},
			//更新
			async rowUpdate(row, index, done, loading) {
				if (!this.checkForm(this.formData)) {
					loading()
					return
				}
				let {apiNameUpdateList} = option
				this.api[apiNameUpdateList ? apiNameUpdateList[parseInt(this.currentIndex)] : 'update'](
					await this.rowUpdateReqData(),
				)
					.then((response) => {
						this.getList()
						this.$message.success('更新成功')
						done()
					})
					.catch(() => {
						loading()
					})
			},

			delReqData(row) {
				return row.id
			},
			//删除数据
			rowDel(row, index) {
				let {name = '', policyNo = '', id = ''} = row
				this.$confirm(`此操作将永久删除【${name || policyNo || id}】，是否继续？`, '提示', {
					confirmButtonText: '确定',
				})
					.then(() => {
						//删除
						let delReqData = this.delReqData(row)
						if (this.validatenull(delReqData)) {
							this.$message.error('请求参数有误')
							return
						}
						let {apiNameDelList} = option
						return this.api[apiNameDelList ? apiNameDelList[this.currentIndex] : 'del'](delReqData)
					})
					.then(() => {
						//刷新数据
						this.getList()
						this.$message.success('删除成功')
					})
					.catch(() => {})
			},

			/**
			 * 打开弹窗前解密字段
			 * @param {*} done
			 * @param {*} type
			 * @returns
			 */
			async onHandleBeforeOpen(done, type) {
				window.boxType = type
				// 解密字段
				let formData = await decryptMessageByObject(this.formData)
				Object.assign(this.formData, formData)
				// 设置表单数据
				this.onHandleBeforeOpenOther(done, type)
			},

			onHandleBeforeOpenOther(done, type) {
				done()
			},

			//搜索
			searchChange(params, done) {
				this.onDealSearchData(params)
				if (done) {
					done()
				}
			},
			onSearchClear() {
				this.onDealSearchData()
			},
			//处理搜索数据
			onDealSearchData(params = {}) {
				//有多选，则去除
				if (this.currentOption.reserveSelection) {
					this.$refs.crud_content.clearSelection()
				}
				this.searchParams = params
				this.page.currentPage = 1
				this.getList()
			},
			//刷新
			refreshChange() {
				this.getList()
			},
			//初始化分页
			initPage() {
				this.page = {
					total: 0,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [20, 40, 80, 100, 500, 1000],
				}
			},
			//前端界面处理钱
			dealFontMoney(responseData, request = '') {
				let showEndorseNo = true
				let tempCommonData = []
				let tempErrorData = []
				responseData.forEach((itemData) => {
					//处理数据金额等
					let {
						payMoney = 0,
						settleMoney = 0,
						ruleItem = {},
						insureType,
						feeRate = 0,
						endorseNo,
						applyItemDTO = {},
						cancelStatus = 0,
						changeCode,
						feePre = 0,
						basicFeeRate = 0,
						additionalFeeRate = 0,
						fee = 0,
						coupon = null,
					} = itemData
					itemData.payMoney = payMoney / 100
					itemData.settleMoney = settleMoney / 100
					if ((changeCode === 201 && feePre) || this.validatenull(ruleItem)) {
						//退保,并且改过值
						itemData.basicFeeRate = '--'
						itemData.basicFee = '--'
						itemData.additionalFeeRate = '--'
						itemData.additionalFee = '--'
					} else {
						if (!this.validatenull(ruleItem)) {
							let tempBasicFeeRate = 0
							let tempAdditionalFeeRate = 0
							if (basicFeeRate !== 0 || additionalFeeRate !== 0) {
								tempBasicFeeRate = basicFeeRate
								tempAdditionalFeeRate = additionalFeeRate
								itemData.fee = (itemData.fee / 100).toFixed(2)
							} else {
								tempBasicFeeRate = ruleItem.basicFeeRate
								tempAdditionalFeeRate = ruleItem.additionalFeeRate
							}
							itemData.basicFeeRate = `${tempBasicFeeRate / 100}%`
							itemData.basicFee = ((settleMoney * tempBasicFeeRate) / 10000 / 100).toFixed(2)
							itemData.additionalFeeRate = `${tempAdditionalFeeRate / 100}%`
							itemData.additionalFee = ((settleMoney * tempAdditionalFeeRate) / 10000 / 100).toFixed(2)
						}
					}
					//预计合计费用
					//为空，则是申请
					if (this.validatenull(applyItemDTO)) {
						if (this.validatenull(ruleItem)) {
							//为空
							itemData.allFeePre = '--'
						} else {
							itemData.allFeePre = feePre
								? (feePre / 100).toFixed(2)
								: ((settleMoney * (ruleItem.basicFeeRate + ruleItem.additionalFeeRate)) / 10000 / 100).toFixed(2)
						}
					} else {
						//详情
						itemData.allFeePre = (applyItemDTO.feePre / 100).toFixed(2)
						//合计费用
						itemData.allFee = (applyItemDTO.fee / 100).toFixed(2)
					}
					if (request === 'getSettleApplyDetailAward' && this.type === 'front') {
						//奖励费率
						itemData.feeRate = feeRate > 0 ? `${feeRate / 100}%` : '--'
						itemData.feePre = feePre > 0 ? (feePre / 100).toFixed(2) : '--'
					} else {
						if (coupon) {
							//奖励费率
							itemData.feeRate = feeRate > 0 ? `${feeRate / 100}%` : '--'
						} else {
							//档次  除了国寿财其他不显示档次
							itemData.feeRate = insureType === 8 ? feeRate : '--'
						}
					}
					if (showEndorseNo && endorseNo) {
						showEndorseNo = false
					}
					//处理数据
					if (payMoney <= 0 || cancelStatus > 0) {
						tempErrorData.push(itemData)
					} else {
						tempCommonData.push(itemData)
					}
				})
				//合并处理数据
				this.listData = tempErrorData.concat(tempCommonData)
				//隐藏批单号
				this.currentOption.column.forEach((itemData) => {
					if (itemData.prop === 'endorseNo') {
						itemData.hide = showEndorseNo
					}
				})
			},
			dealAwardFontMoney(data, applyType = true) {
				if (data && data.length > 0) {
					data.forEach((itemData) => {
						let {payMoney = 0, feeRate = 0, feePre = 0} = itemData
						itemData.payMoney = payMoney / 100
						itemData.feeRate = feeRate !== 0 || applyType ? `${feeRate / 100}%` : '--'
						itemData.feePre = feePre !== 0 || applyType ? (feePre / 100).toFixed(2) : '--'
					})
				}
			},
			onChangeIndex() {},
			//格式化列表数据  -预留给页面自定义处理数据时候使用
			formaterListData(data) {
				return data
			},
		},
	}

	// 安装导出插件
	baseCrudExportPlugin.install(mixins, option)

	app.mixins = app.mixins || []
	app.mixins.push(mixins)
	return app
}
